import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  output,
} from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import type { RtButtonVariant } from '../../common/button/button.types';
import { ButtonComponent } from '../../common/button/components/button/button.component';
import { ButtonDropdownIndicatorDirective } from '../../common/button/directives/button-dropdown/button-dropdown-indicator.directive';
import { DropdownItemComponent } from '../../common/dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent, DropdownWidth } from '../../common/dropdown/dropdown.component';
import {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  OverlayPosition,
} from '../../core/overlay/overlay-directives';
import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
  templateUrl: './bulk-select.component.html',
  styleUrls: ['./bulk-select.component.less'],
  selector: 'rt-bulk-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.active]': 'active',
  },
  imports: [
    ButtonComponent,
    ButtonDropdownIndicatorDirective,
    CheckboxComponent,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    NgClass,
    OverlayOriginDirective,
    TranslatePipe,
  ],
})
export class BulkSelectComponent {
  public readonly OverlayPosition: typeof OverlayPosition = OverlayPosition;

  @Input() public allSelected: boolean = false;
  @Input() public selectedCount: number = 0;
  @Input() public disabled: boolean = false;
  @Input() public active: boolean = false;
  @Input() public indeterminateState: boolean = false;
  @Input() public variant: Extract<RtButtonVariant, 'tertiary' | 'outline'> = 'tertiary';

  // emits true if select all, false if select none
  public select = output<boolean>();

  public DropdownWidth = DropdownWidth;
  public dropdownOpened = false;

  constructor(protected cdRef: ChangeDetectorRef) {}

  public toggleDropdown(dropdownOpened: boolean = !this.dropdownOpened): void {
    this.dropdownOpened = dropdownOpened;
    this.cdRef.detectChanges();
  }
}
